import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import API, { getloginUserId } from "../api/axios";
import { toast } from "react-toastify";
import Layout from "../components/Layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTag,
  faArrowUp,
  faEdit,
  faRemove,
  faUnlock,
} from "@fortawesome/free-solid-svg-icons";
import Loader from "../components/Loader";
import { confirmToast } from "../utils/toastConfirm";

const MyProjects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const [unlock_reason, setunlock_reason] = useState("");
  const [activeCycle, SetactiveCycle] = useState(null);
  
  const fetchProjects = async () => {
    try {
      const userId = getloginUserId();
      const response = await API.get(`/user-projects/${userId}`);
      setProjects(response.data.data.data || []);
      SetactiveCycle(response.data.active_cycle_id);
      console.log(`active cycle id print here ${response.data.active_cycle_id}`);
    } catch (err) {
      console.error(err);
      toast.error("Failed to load your projects");
    } finally {
      setLoading(false);
    } 
  };


  const handleDelete = (id) => {
    confirmToast("Are you sure you want to delete this project?", async () => {
      try {
        await API.delete(`/projects/${id}`);
        toast.success("Project deleted successfully");
        fetchProjects();
      } catch (err) {
        console.error(err);
        toast.error("Failed to delete project");
      }
    });
  };

  const handleRequest = (id) => {
    setSelectedProject(id);
    setunlock_reason("");
    setShowModal(true);
  };

  const submitRequest = async () => {
  if (!unlock_reason.trim()) {
    toast.error("reason is required");
    return;
  }

  try {
    await API.post(`/projects/${selectedProject}/unlock-request`, { unlock_reason });
    toast.success("Request submitted successfully");
    setShowModal(false);
    setSelectedProject(null);
    setunlock_reason("");
  } catch (err) {
    console.error(err);
    toast.error("Failed to submit request");
  }
};
  
  useEffect(() => {
    fetchProjects();
  }, []);

  return (
    <Layout>
      <h2 className="mb-4">My Projects</h2>
      <div className="row p-2">
        {loading ? (
          <Loader></Loader>
        ) : projects.length === 0 ? (
          <p>No projects found.</p>
        ) : (
          <div className="space-y-4">
            {projects.map((project, index) => (

             

              <div
                className="col-md-12 col-lg-12 mb-4"
                key={project.id}
                data-index={project.id}
                data-item-index={index}
              >
                <div className="row align-items-center border p-2 rounded shadow">
                  <div className="col-md-2">
                  <img
                    src={project.logo_url || "./default_project_img.png"}
                    className="rounded"
                    alt={project.name || "default project image"}
                    onError={(e) => { e.target.src = "./default_project_img.png"; }}
                  />
                </div>

                  <div className="col-md-7">
                    <h6 className="mb-1 text-muted fw-semibold small">
                       {project.name.charAt(0).toUpperCase() + project.name.slice(1)}
                    </h6>
                    <div className="fw-normal mb-1 small">
                      {project.tagline}
                    </div>
                    <div className="d-flex align-items-center text-muted small">
                      <span className="me-3 project-category-list">
                        <FontAwesomeIcon icon={faTag} />
                        {project.categories.map((cat) => cat.name).join(", ")}
                      </span>
                      <span
                        className={`badge ms-2 ${project.is_approved ? "bg-success" : "bg-warning"
                          }`}
                      >
                        {project.is_approved ? "Approved" : "Pending"}
                      </span>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="d-flex justify-content-end gap-2">
                      <>
                       <Link
                        to={`/edit-project/${project.id}`}
                        className={`btn btn-sm border rounded-circle p-1 ${
                          activeCycle !== project.cycle_id && project.request_unlock_status !== "approved"   
                            ? "disabled-link"
                            : ""
                        }`}
                        aria-disabled={
                         
                          activeCycle !== project.cycle_id && project.request_unlock_status !== "approved"
                            ? "true"
                            : "false"
                        }
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </Link>

                        <button
                        className="btn btn-sm border rounded-circle p-1"
                        onClick={() => handleDelete(project.id)}
                        disabled={activeCycle !== project.cycle_id && project.request_unlock_status !== 'approved'}
                      >
                        <FontAwesomeIcon icon={faRemove} />
                      </button>

                      {activeCycle !== project.cycle_id && project.request_unlock_status !== "approved" && (
                        <button
                          className="btn btn-sm border rounded-circle p-1"
                          onClick={() => handleRequest(project.id)}
                          disabled={project.request_unlock_status === 'pending'}
                          style={{
                            color: project.request_unlock_status === 'rejected' ? 'red' : 'inherit',
                          }}
                          title={project.request_unlock_status === 'rejected' ? 'Unlock Request Rejected' : 'Add Unlock Request '}
                        >
                          <FontAwesomeIcon icon={faUnlock} />
                        </button>
                      )}
                      </>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      {showModal && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Unlock Request</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">Reason</label>
                  <textarea
                    className="form-control"
                    value={unlock_reason}
                    onChange={(e) => setunlock_reason(e.target.value)}
                    rows="3"
                    placeholder="Enter reason for unlock request..."
                  ></textarea>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={submitRequest}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

    </Layout>
  );
};

export default MyProjects;
